import React, { useRef, useEffect } from 'react';

/**
 * Will focus the first focusable child on mount if props.focusIf is true or
 * undefined.  (otherwise known as first-render)
 *
 * This is a helper component that helps maintain focus.  A big rule of keyboard
 * accessibility is to not remove focus without moving it somewhere else
 * @see https://stackoverflow.com/a/63849350
 *
 * @param props.focusIf Set to false if you don't want to focus on mount
 * @param focus.onFocus Callback that is called after focus is changed
 */
export function FocusOnMount(props) {
  var ref = useRef();
  var isMountedRef = useRef();
  useEffect(function () {
    if (!isMountedRef.current && ref.current && (props.focusIf === true || typeof props.focusIf === 'undefined')) {
      var _props$onFocus;
      var firstFocusableElement = ref.current.querySelector('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
      if (firstFocusableElement instanceof HTMLElement) {
        firstFocusableElement.focus();
      }
      (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 ? void 0 : _props$onFocus.call(props);
    }
    isMountedRef.current = true;
  }, [props.focusIf, props.onFocus]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, props.children);
}